import { render, staticRenderFns } from "./limit-number.vue?vue&type=template&id=77a92796&scoped=true&"
import script from "./limit-number.vue?vue&type=script&lang=js&"
export * from "./limit-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a92796",
  null
  
)

export default component.exports